import { render, staticRenderFns } from "./card-vital-slider-02.vue?vue&type=template&id=6b7c0a60&scoped=true&"
import script from "./card-vital-slider-02.vue?vue&type=script&lang=js&"
export * from "./card-vital-slider-02.vue?vue&type=script&lang=js&"
import style0 from "./card-vital-slider-02.vue?vue&type=style&index=0&id=6b7c0a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7c0a60",
  null
  
)

export default component.exports